<template>
  <div class="rule-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="content" @touchmove.stop>
          <div class="rule-h1">活动规则</div>
          <div class="rule-h2">一、活动入口和权益领取路径</div>
          <section class="rule-block">
            <p class="rule-p">
              手机银行APP-活动中心-财富晋升计划
            </p>
          </section>

          <div class="rule-h2">二、活动规则</div>
          <section class="rule-block">
            <div class="rule-h4">1. 活动对象</div>
            <p class="rule-p">活动期间首次开立借记卡一类户客户</p>

            <div class="rule-h4">2. 活动时间</div>
            <p class="rule-p">活动参与时间：2026年4月10日-2026年6月30日</p>
            <p class="rule-p">权益领取时间：2026年5月5日-2026年8月31日</p>

            <div class="rule-h4">3. 活动内容</div>
            <p class="rule-p">
              活动期间首次开立借记卡一类户且开户当月或次月成为本行财富客户/白金客户/黑金客户/私钻客户即可获得1次开宝箱机会，具体客户等级对应抽奖礼品如下，<span
                class="rule-em rule-em--accent">数量有限，先到先得，领完为止</span>：
            </p>
            <p class="rule-p">
              (1) 达标财富客户：可随机抽取58元或88元微信立减金一份；
            </p>
            <p class="rule-p">
              (2) 达标白金客户：可随机抽取158元或218元微信立减金一份；
            </p>
            <p class="rule-p">
              (3) 达标黑金客户：可随机抽取318元或388元微信立减金一份；
            </p>
            <p class="rule-p">
              (4) 达标私钻客户：可随机抽取518元或688元微信立减金一份；
            </p>
            <p class="rule-p rule-p--mt">各档位立减金数量如下：</p>
            <table class="rule-table">
              <thead>
                <tr>
                  <th>开户次月内客户等级</th>
                  <th>权益</th>
                  <th>数量</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="2">财富</td>
                  <td>58元微信立减金</td>
                  <td>1119</td>
                </tr>
                <tr>
                  <td>88元微信立减金</td>
                  <td>81</td>
                </tr>
                <tr>
                  <td rowspan="2">白金</td>
                  <td>158元微信立减金</td>
                  <td>648</td>
                </tr>
                <tr>
                  <td>218元微信立减金</td>
                  <td>156</td>
                </tr>
                <tr>
                  <td rowspan="2">黑金</td>
                  <td>318元微信立减金</td>
                  <td>90</td>
                </tr>
                <tr>
                  <td>388元微信立减金</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td rowspan="2">私钻</td>
                  <td>518元微信立减金</td>
                  <td>21</td>
                </tr>
                <tr>
                  <td>688元微信立减金</td>
                  <td>6</td>
                </tr>
              </tbody>
            </table>

            <div class="rule-h4">4. 活动规则</div>
            <p class="rule-p">
              （1）以上等级奖励只限领取1次，不可重复获取。
            </p>
            <p class="rule-p">
              （2）客户当月等级由系统于次月5日出具结果并判断是否达标，若达标可开启宝箱抽取对应档位的奖品。活动期间权益宝箱只能开启1次，领取资格当月有效，若当月资格未领取，次月将根据当月达标情况重新判断宝箱开启等级。若开户次月5日达标后未操作开启宝箱，系统将持续跟踪下个月的资产等级，并取两个月的最高等级作为最终结果。客户可根据自身情况选择宝箱开启时间，<span
                class="rule-em rule-em--accent">最迟领取和兑换时间为开户月后2个自然月内，超期不予补发</span>。
            </p>
            <p class="rule-p">
              权益领取路径：厦门国际银行APP-活动中心-二季度财富晋升计划
            </p>
            <p class="rule-p rule-p--strong">举例：</p>
            <p class="rule-p">
              客户4月开户，5月5日系统判断显示等级提升为白金，但客户选择不开启宝箱，2026年6月5日系统判断等级较5月5日结果未提升，仍可于当日起在权益领取时间内抽取白金等级礼品。
            </p>
            <p class="rule-p">
              客户4月开户，5月5日系统判断显示等级提升为白金，可于当日起至6月5日前抽取白金等级礼品，抽取完毕后，若6月5日等级进一步提升为黑金，也不可再抽取黑金对应礼品。
            </p>
            <p class="rule-p">
              客户4月开户，5月5日系统判断显示等级提升为白金，但客户选择不开启宝箱，待2026年6月5日系统判断等级进一步提升至黑金后开启宝箱，可于6月5日起在权益领取时间内抽取黑金对应礼品。
            </p>
          </section>

          <div class="rule-h2">三、权益使用说明</div>
          <section class="rule-block">
            <p class="rule-p">
              1、微信立减金领取后10天有效，有效期以微信卡包显示为准，过期不补。
            </p>
            <p class="rule-p">
              2、使用厦门国际银行借记卡进行微信支付满足立减金消费门槛自动抵扣，具体使用范围以实际抵扣为准。
            </p>
            <p class="rule-p">
              3、享受优惠的订单，如发生全额退款，且立减金仍在有效期内，立减金将自动退还给用户。如发生部分退款，用户支付金额将按比例原路退还，立减金将按比例退还给用户，用户可继续使用。如立减金已过期，则不退还给用户。
            </p>
            <p class="rule-p">
              4、立减金仅限商业支付时使用，社交支付（如转账、红包、个人收款码支付等）不可用。不可使用商户：肯德基、必胜客、CoCo奶茶、Five Plus、Miss
              Sixty、ochirly、CovenGarden、Denham、孩子王、热风、太平鸟、优衣库、广东电信、星巴克、珠海城建、航联、微众银行、分付、零钱通、理财通、信用卡还款、腾安基金、哔哩哔哩、华为商城、北京市医院管理中心等。合单支付（微信支付订单号为44开头的交易）无法使用立减金；中国境外商户无法使用立减金。
            </p>
            <p class="rule-p">
              5、本券不找零，不可兑换为现金，不可转让，优惠金额部分不开具发票。
            </p>
            <p class="rule-p">
              6、同一微信号、同一手机号、同一身份证号、同一设备号等，符合其中任意条件视为同一用户。
            </p>
          </section>

          <div class="rule-h2">四、温馨提示</div>
          <section class="rule-block">
            <p class="rule-p">
              （一）参与默认规则：参与活动即视为同意活动规则，提醒参与者提前仔细阅读。
            </p>
            <p class="rule-p">
              （二）免责声明：因客户操作不当或网络、运营商故障等非银行可控原因致无法参与活动，我行不予负责。
            </p>
            <p class="rule-p">
              （三）规则变动权：银行可依活动实际情况，在法律允许范围内变动调整活动规则，并通过手机银行客户端、银行公众号公布，公布后即时生效。
            </p>
            <p class="rule-p">
              （四）支持与客服：本活动由易点生活电子商务有限公司支持。领取有问题工作日9:00-21:00拨打400-662-7299；其他疑问每日8:30-20:00拨打厦门国际银行客服热线956085。
            </p>
          </section>
        </div>
        <div class="close-btn" @click="onClose">
          <span class="x">×</span>
        </div>
      </div>
    </van-overlay>
  </div>
  <!-- 细则弹框组件 -->
</template>

<script>
export default {
  name: "RuleModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClose() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="less" scoped>
.rule-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    // padding-top: 70px;
    box-sizing: border-box;
  }

  .content {
    background: linear-gradient(to bottom,
        #fdd3e6 0%,
        #ffffff 40%,
        #ffffff 100%);
    border-radius: 20px;
    padding: 0 19px 12px;
    box-sizing: border-box;
    color: #000301;
    width: 85%;
    margin: 0 auto;
    max-height: min(60vh, calc(100dvh - 120px));
    overflow: auto;

    .rule-h1 {
      font-size: 20px;
      color: #b33e12;
      text-align: center;
      font-weight: bold;
      padding: 28px 0 0px;
    }

    .rule-h2 {
      font-size: 16px;
      font-weight: 700;
      color: #111;
      margin: 18px 0 10px;
      line-height: 1.35;

      &:first-of-type {
        margin-top: 0;
      }
    }

    .rule-block {
      margin-bottom: 4px;
    }

    .rule-h3 {
      font-size: 15px;
      font-weight: 700;
      color: #111;
      margin: 14px 0 8px;
      line-height: 1.4;
    }

    .rule-h4 {
      font-size: 14px;
      font-weight: 600;
      color: #222;
      margin: 12px 0 6px;
      line-height: 1.4;
    }

    .rule-p {
      margin: 0 0 8px;
      font-size: 12px;
      line-height: 1.65;
      color: #333;
      text-align: justify;

      &--mt {
        margin-top: 4px;
      }

      &--strong {
        font-weight: 600;
        color: #222;
      }
    }

    .rule-em {
      font-weight: inherit;

      &--accent {
        color: #e54c5e;
      }

      &--red {
        color: #ff0000;
      }
    }

    .rule-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 11px;
      margin: 8px 0 14px;
      color: #333;

      th,
      td {
        border: 1px solid #ddd;
        padding: 6px 4px;
        text-align: center;
        vertical-align: middle;
      }

      th {
        background: #f5f5f5;
        font-weight: 600;
      }
    }
  }

  .close-btn {
    margin-top: 16px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2.5px solid rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.25);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);

    .x {
      font-size: 20px;
      color: #fff;
      line-height: 30px;
      display: block;
    }
  }
}
</style>
